import React from "react";
import Nav from "react-bootstrap/Nav";
import logo from '../../Assets/Images/buypolicynow.png';
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoPersonOutline } from "react-icons/io5";
import { CiLinkedin } from "react-icons/ci";
import { FaFacebook } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import { FiPhoneCall } from "react-icons/fi";
import { Link } from "react-router-dom";
import FooterIcon from "../../Assets/Images/imgWhyBuyPolicyNow2FooterBPN.png"

const Footer = () => {
  function handleVerticalScroll() {
    window.scrollTo({
      top: 1500,
      behavior: 'smooth'
    });
  }
  return (
    <>
      <div className="container " style={{ margin: '0', maxWidth: '100%', padding: "0px 12px" }}>
        <div>

          <div className="row">
            <div className="col-md-4 col-sm-12" style={{ padding: "0" }}>
              <div className="background-for-logo-side container py-5 ps-5">
                <div>
                  <img className=" " style={{ height: "120px", width: "140px" }} src={logo} alt="logo" />
                </div>
                <div className="mt-3">
                  Integrated Risk Insurance Brokers Limited<br />
                  S.C.O. 201-203, 3rd Floor, Sector 34-A,<br />
                  Chandigarh – 160022
                </div>
                <div className="row mt-3">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    Email:<br />
                    <a style={{ color: "#fda34b" }} href="mailto:info@buypolicynow.com">info@buypolicynow.com</a>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    Available when you need us:<br />
                    <a style={{ color: "#007bff" }} href="tel:+919022264444">+91 9022264444</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-sm-12" style={{ padding: "0" }}>
              <div className="background-for-quicklinks-side container py-5 pe-5 ps-4 " style={{ color: "white" }}>
                <div className="row">
                  <div className="col-md-3">
                    <h4>Product</h4>
                    <ul className="footer-list-links">
                      <li className="">
                        <Link to="/motor-insurance/car-insurnace" className="" style={{ color: "#ffffffb3" }}>Car</Link>
                      </li>
                      <li className="">
                        {/* <Link to="/motor-insurance" className="" style={{ color: "#ffffffb3" }}>Bike</Link> */}
                        <Link to="#" className="" style={{ color: "#ffffffb3" }}>Bike</Link>
                      </li>
                      <li className="">
                        {/* <Link to="/health-insurance" className="" style={{ color: "#ffffffb3" }}>Health</Link> */}
                        <Link to="#" className="" style={{ color: "#ffffffb3" }}>Health</Link>
                      </li>
                      <li className="">
                        {/* <Link to="/life-insurance" className="" style={{ color: "#ffffffb3" }}>Life</Link> */}
                        <Link to="#" className="" style={{ color: "#ffffffb3" }}>Life</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-3">
                    <h4>About</h4>
                    <ul className="footer-list-links">
                      <li className="">
                        <Link to={`${process.env.PUBLIC_URL}/about`} className="" style={{ color: "#ffffffb3" }}>About Us</Link>
                      </li>
                      <li className="">
                        <Link to={`${process.env.PUBLIC_URL}/our-philosophy`} className="" style={{ color: "#ffffffb3" }}>Our Philosophy</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <img src={FooterIcon} alt="icon" style={{ width: "100%" }} />
                  </div>

                </div>
                <div className="text-center mt-4">
                  Integrated Risk Insurance Brokers Limited is an IRDA Licensed Direct Broker | CIN: U74999DL2003PLC118781 | Certificate No. 240, Registration Date: 04 Jan 2004, Valid till 04 Jan 2025 (Renewable), License category: Direct Broker (Life & General) | Visitors are hereby informed that their information submitted on the website may be shared with insurers. Product information is authentic and solely based on the information received from the insurers.
                </div>
                <div className="text-center mt-3">
                  © Copyright 2014-2024 Buypolicynow. All Rights Reserved.
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>


    </>
  );
};

export default Footer;
